var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRwwBrandmarkWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299.046,
    height: 299.027,
    viewBox: "0 0 79.123 79.118",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0883156,
      strokeMiterlimit: 5.6,
      strokeDasharray: "none"
    },
    width: 70.72,
    height: 69.257,
    x: 6.303,
    y: 6.243,
    ry: 16.568,
    transform: "matrix(.95258 0 0 .97103 -.126 -.129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264999,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 7,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "M84.84 107.832a22.144 22.144 0 0 0-22.191 22.192v37.095A22.143 22.143 0 0 0 84.84 189.31h38.678a22.143 22.143 0 0 0 22.191-22.191v-37.095a22.143 22.143 0 0 0-22.191-22.192zm.548 6.11h37.583c9.18 0 16.568 7.39 16.568 16.569v36.12c0 9.18-7.389 16.57-16.568 16.57H85.388a16.532 16.532 0 0 1-16.568-16.57v-36.12c0-9.179 7.39-16.568 16.568-16.568z",
    transform: "matrix(.95258 0 0 .97103 -59.678 -104.708)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.275161,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 7,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "M127.753 154.827v-20.422a10.423 10.423 0 0 0-10.446-10.446H88.83c-2.893 0-10.443.02-10.443.02l-.003 10.426v28.333a10.423 10.423 0 0 0 10.446 10.446h31.011c-6.137-2.007-11.979-5.374-17.44-10.49-2.007 1.295-4.04 2.538-6.708 2.508a9.593 9.593 0 0 1-9.614-9.614v-14.034c0-2.663-.023-9.6-.023-9.6s6.974-.013 9.637-.013h14.243a9.593 9.593 0 0 1 9.614 9.613c-.296 2.115-1.462 4.597-5.252 8.19 3.818 2.88 8.421 4.363 13.454 5.083z",
    transform: "matrix(.95258 0 0 .97103 -59.678 -104.708)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: ".264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 7,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "M93.598 136.158c-3.76 5.275-2.88 16.524-2.88 16.524s1.5-6.77 3.298-9.032c12.609 21.83 27.643 28.11 38.494 29.172v-6.267s-27.17-1.793-38.912-30.397z",
    transform: "matrix(.95258 0 0 .97103 -59.678 -104.708)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: ".264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 7,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "M94.345 135.745c3.896-.762 13.235.223 13.235.223s-5.872 1.875-8.335 3.096c8.956 17.45 33.19 20.127 33.265 20.134v5.872s-25.467-1.723-38.165-29.325z",
    transform: "matrix(.95258 0 0 .97103 -59.678 -104.708)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRwwBrandmarkWhite);
export default __webpack_public_path__ + "static/media/rww-brandmark-white.3d357214.svg";
export { ForwardRef as ReactComponent };